import { Colophon } from "../types/colophon";
import BaseEntityService from "./baseEntityService";

const serviceUrlSuffix = "v1/colophons";

class ColophonService extends BaseEntityService<Colophon> {
  constructor() {
    super(serviceUrlSuffix);
  }
}

export const colophonService = new ColophonService();
